import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCycleArrows = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "sync_alt",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_852_7946",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 16,
				height: 16,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_852_7946)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "sync_alt_2",
				d: "M4.66603 13.7689L1.56348 10.6664L4.66603 7.5638L5.37883 8.26635L3.47881 10.1664H13.8327V11.1663H3.47881L5.37883 13.0664L4.66603 13.7689ZM11.3327 8.43557L10.6199 7.73302L12.5199 5.833H2.16604V4.83304H12.5199L10.6199 2.93302L11.3327 2.23047L14.4352 5.33302L11.3327 8.43557Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgCycleArrows;
